module.exports = __webpack_public_path__ + "img/Emptying_the_Powder.5b2c5e57.png";